import { code } from "@spscommerce/utils";

export const SpsPaginationExamples = {
    basic: {
        label: "Pagination",
        description: "info about pagination",
        examples: {
            basic: {
                template: code`
                    <sps-pagination id="basic" [totalResults]="total" [pageSizeOptions]="[7, 39, 201]"></sps-pagination>
                `,
                class: code`
                    class DemoComponent {
                        total = 123;
                    }
                `
            },
            withDefaultPage: {
                template: code`
                    <sps-pagination id="eventHandled" [totalResults]="total" [page]="currentPage" [pageSize]="pageSize" (change)="onPaginationChange($event)">
                    </sps-pagination>
                    <p>
                        Event data from last invocation of onPaginationChange:
                        {{ lastChangeEvent | json }}
                    </p>
                `,
                class: code`
                    class DemoComponent {
                        total = 123;
                        currentPage = 2;
                        pageSize = 50;
                        lastChangeEvent;

                        onPaginationChange(event) {
                            this.lastChangeEvent = event;
                        }

                        onPageChange(newPage) {
                            console.log("new page:", newPage);
                        }
                    }
                `
            }
        }
    },
    pageSelector: {
        label: "Page Selector",
        description: "info about page selector",
        examples: {
            basic: {
                template: code`
                    <sps-page-selector [(page)]="pageSelectorCurrentPage" (pageChange)="onPageChange($event)" [numPages]="34">
                    </sps-page-selector>
                `,
                class: code`
                    class DemoComponent {
                        pageSelectorCurrentPage;

                        onPageChange(newPage) {
                            console.log("new page:", newPage);
                        }
                    }
                `
            }
        }
    }
};
